module.exports = Object.freeze({
    ALERT: "Thông báo",
    EXITED_USERNAME: "Tên đăng nhập đã tồn tại",
    EXITED_EMAIL: "Email đã tồn tại",
    ACCESS_EXPIRE: "Phiên làm việc đã kết thúc xin hãy đăng nhập lại",
    PASSWORD_ERROR: "Mật khẩu không chính xác",
    EMAIL_ERROR: "Email đã tồn tại hoặc sai cú pháp",
    USERNAME_ERROR: "Tên đăng nhập đã tồn tại hoặc sai cú pháp",
    FULL_NAME_ERROR: "Tên người dùng không chính xác",
    SUCCESS: "Thành công",
    SUCCESS_EMAIL: "Gửi e-mail kiểm tra cấu hình thành công",
    SUCCESS_EDITED: "Chỉnh sửa thành công",
    SUCCESS_RESTORE: "Khôi phục thành công",
    SUCCESS_ADDED_DATA: 'Thêm dữ liệu thành công',
    SUCCESS_SAVED: "Lưu thành công",
    SUCCESS_DELETED_WORK_HISTORY: "Xóa lịch sử công việc thành công",
    SUCCESS_DELETED_DEPARTMENT: 'Xóa đơn vị thành công!',
    SUCCESS_DELETED_FAIL: 'Xóa phòng ban thất bại vui lòng kiểm tra lại',
    INPUT_INFORMATION_ERROR: "Thông tin nhập không chính xác",
    TYPE_IMAGE_ERROR: "Kiểu file ảnh không đúng",
    CONNECTION_ERROR: "Có lỗi kết nối xin hãy thử lại",
    CONTINUE: "Bạn có muốn tiếp tục thao tác không?",
    CONTINUE_LOGOUT: "Bạn có muốn đăng xuất không?",
    NO_PERMISSION_VIEW_PAGE: "Bạn không có quyền truy cập vào trang này!",
    YES: "Có",
    NO: "Không",
    NO_RESULTS: 'Không có kết quả phù hợp',
    NO_DATA: 'Không có dữ liệu',
    ERROR_LOGIN: 'Lỗi đăng nhập thất bại, vui lòng kiểm tra lại',
    LOCK_ACCOUNT: 'Tài khoản đã bị khóa, xin vui lòng liên hệ với Quản trị viên để hỗ trợ.'
});
